import { Button, Card, Table } from 'react-bootstrap';
import { ArrowDown, ArrowUp, Eye } from 'react-bootstrap-icons';

import Paginacion from '../Paginacion';
import {
  formatDate,
  formatNumber,
} from '../../utils/partidasFormatters';
import PartidaEstadoBadge from './PartidaEstadoBadge';

const SortHeader = ({ field, label, sortField, ascending, onSort, className = '' }) => (
  <th className={className}>
    {onSort ? (
      <button type='button' className='partidas-sort-button' onClick={() => onSort(field)}>
        {label}
        {sortField === field && (ascending ? <ArrowUp /> : <ArrowDown />)}
      </button>
    ) : (
      label
    )}
  </th>
);

const MobileCard = ({ row, onView }) => (
  <Card className={`partidas-mobile-card ${row.alerta_despacho ? 'is-audit-alert' : ''}`}>
    <Card.Body>
      <div className='partidas-mobile-card-header'>
        <div>
          <span>Artículo {row.codigo_articulo}</span>
          <h3>{row.detalle}</h3>
        </div>
        <PartidaEstadoBadge estado={row.estado_vencimiento} />
      </div>
      {row.alerta_despacho && (
        <div className='partidas-audit-row-label'>Salida en la partida posterior</div>
      )}
      <div className='partidas-mobile-info'>
        <div><span>Partida</span><strong>{row.numero_partida}</strong></div>
        <div><span>Proveedor</span><strong>{row.proveedor || 'Sin proveedor'}</strong></div>
        <div><span>Vencimiento</span><strong>{formatDate(row.fecha_vencimiento)}</strong></div>
        <div><span>Saldo</span><strong>{formatNumber(row.cantidad_saldo)}</strong></div>
      </div>
      <Button variant='outline-primary' onClick={() => onView(row)}>
        <Eye /> Ver detalle
      </Button>
    </Card.Body>
  </Card>
);

export default function PartidasTable({
  rows,
  total,
  page,
  pageSize,
  onPageChange,
  sortField,
  sortAscending,
  onSort,
  onView,
  auditMode = false,
}) {
  const totalPages = auditMode ? 1 : Math.max(1, Math.ceil(total / pageSize));

  return (
    <>
      {!auditMode && totalPages > 1 && (
        <div className='crm-table-pagination is-top'>
          <Paginacion pagina={page} totalPaginas={totalPages} onChange={onPageChange} />
        </div>
      )}

      <div className='d-none d-lg-block partidas-table-scroll'>
        <Table striped hover responsive size='sm' className='partidas-table align-middle text-center mb-0'>
          <thead className='table-light'>
            <tr>
              <SortHeader
                field='detalle'
                label='Producto'
                sortField={sortField}
                ascending={sortAscending}
                onSort={auditMode ? null : onSort}
                className='text-start'
              />
              <SortHeader
                field='codigo_articulo'
                label='Código'
                sortField={sortField}
                ascending={sortAscending}
                onSort={auditMode ? null : onSort}
              />
              <SortHeader
                field='proveedor'
                label='Proveedor'
                sortField={sortField}
                ascending={sortAscending}
                onSort={auditMode ? null : onSort}
              />
              <SortHeader
                field='numero_partida'
                label='Partida'
                sortField={sortField}
                ascending={sortAscending}
                onSort={auditMode ? null : onSort}
              />
              <SortHeader
                field='fecha_vencimiento'
                label='Vencimiento'
                sortField={sortField}
                ascending={sortAscending}
                onSort={auditMode ? null : onSort}
              />
              <th>Entrada</th>
              <th>Salida</th>
              <SortHeader
                field='cantidad_saldo'
                label='Saldo'
                sortField={sortField}
                ascending={sortAscending}
                onSort={auditMode ? null : onSort}
              />
              <th>Estado</th>
              <th aria-label='Acciones'>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id} className={row.alerta_despacho ? 'partidas-audit-alert-row' : ''}>
                <td className='text-start partidas-product-cell'>
                  <strong>{row.detalle}</strong>
                  {row.alerta_despacho && <span>Salida en partida posterior</span>}
                </td>
                <td>{row.codigo_articulo}</td>
                <td>{row.proveedor || 'Sin proveedor'}</td>
                <td>{row.numero_partida}</td>
                <td>{formatDate(row.fecha_vencimiento)}</td>
                <td>{formatNumber(row.cantidad_entrada)}</td>
                <td>{formatNumber(row.cantidad_salida)}</td>
                <td><strong>{formatNumber(row.cantidad_saldo)}</strong></td>
                <td><PartidaEstadoBadge estado={row.estado_vencimiento} /></td>
                <td>
                  <Button
                    variant='outline-primary'
                    size='sm'
                    className='partidas-view-button'
                    onClick={() => onView(row)}
                    title='Ver detalle'
                    aria-label={`Ver partida ${row.numero_partida}`}
                  >
                    <Eye />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <div className='d-lg-none partidas-mobile-list'>
        {rows.map((row) => <MobileCard key={row.id} row={row} onView={onView} />)}
      </div>

      {!auditMode && totalPages > 1 && (
        <div className='crm-table-pagination is-bottom'>
          <Paginacion pagina={page} totalPaginas={totalPages} onChange={onPageChange} />
        </div>
      )}
    </>
  );
}
